/**
 * Client entry point. The lightweight shell and auth forms are always registered. The heavier views
 * (lobby and game, which pull in SignalR and the offline WASM loader) are dynamically imported only
 * when their custom element is actually present on the page — this keeps the initial JS payload small
 * and lets the browser code-split those chunks.
 */
import './components/gc-app-shell.js';
import './components/gc-offline-banner.js';
import './components/gc-play-offline.js';
import './components/gc-online-only.js';
import './components/gc-install-prompt.js';
import './components/gc-login-form.js';
import './components/gc-register-form.js';
import './components/gc-forgot-password-form.js';
import './components/gc-reset-password-form.js';
import { bootstrapApp } from './app-bootstrap.js';

bootstrapApp();

// Lazy-load page-specific, heavier components only when the SSR'd HTML uses them.
if (document.querySelector('gc-lobby-view')) {
  void import('./components/gc-lobby-view.js');
}
if (document.querySelector('gc-game-table')) {
  void import('./components/gc-game-table.js');
}
if (document.querySelector('gc-game-replay')) {
  void import('./components/gc-game-replay.js');
}
if (document.querySelector('gc-account-manager')) {
  void import('./components/gc-account-manager.js');
}
if (document.querySelector('gc-player-profile')) {
  void import('./components/gc-player-profile.js');
}
if (document.querySelector('gc-global-stats')) {
  void import('./components/gc-global-stats.js');
}
if (document.querySelector('gc-offline-fallback')) {
  void import('./components/gc-offline-fallback.js');
}

